<template>
    <div>
        <Title title="账户信息" path="/my" :tablist="tabs" :tabactive="tab_active" @titleTabActive="titleTabActive"/>

        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <div class="userwrap" v-else>

                    <div class="accinfo accinfo1" v-if="tab_active  === 0">
                        <ul>
                            <li><span class="tit">账号</span><div class="con">{{ info.account }}</div></li>
                            <li><span class="tit">昵称</span>
                                <div class="con" v-if="nickUpdate">
                                    <div class="nicc"><input type="text" v-model="nickname" ref="nick" placeholder="输入昵称" autocomplete="off"></div>
                                    <button type="button" class="ok" @click="submitNK">确定</button>
                                    <button type="button" class="cl" @click="cancelNK">取消</button>
                                </div>
                                <div class="con" v-else>{{ info.name }}<span class="nick" @click="updateNK">修改</span></div>
                            </li>
                            <li><span class="tit">注册</span><div class="con" v-if="info.reg_time != null">{{ info.reg_time }}</div></li>
                        </ul>
                    </div>

                    <div class="accinfo accinfo2" v-else>
                        <ul>
                            <li>
<!--                                <span class="tit">旧密码</span>-->
                                <div class="con">
                                <input type="password" v-model="password1" ref="lgpwd1" placeholder="输入旧密码" autocomplete="off"/>
                            </div></li>
                            <li>
<!--                                <span class="tit">新密码</span>-->
                                <div class="con">
                                <input type="password" v-model="password2" ref="lgpwd2" placeholder="输入新密码" autocomplete="off"/>
                                <div class="tips" v-if="pwd2_err"><i></i>密码由6～20位，区分字母大小写。可由字母、数字、特殊字符组成。</div>
                            </div>
                            </li>
                            <li>
<!--                                <span class="tit">确认密码</span>-->
                                <div class="con">
                                <input type="password" v-model="password3" ref="lgpwd3" placeholder="输入新密码" autocomplete="off"/>
                                <div class="tips" v-if="pwd3_err"><i></i>两次新密码必须一致</div>
                            </div>
                            </li>
                            <li>
<!--                                <span class="tit">验证码</span>-->
                                <div class="con">
                                    <input type="number" v-model="yzmcode" ref="lgcode" placeholder="输入验证码" autocomplete="off"/>
                                    <yzcode @getIdentifyCode="valcode" :changeCode="changeCode" :contentWidth="80" :contentHeight="24" :fontSizeMin="20" :fontSizeMax="25" class="code"/>
                                </div>
                            </li>
                            <li>
                                <button type="button" @click="updatePwd">确定</button>
                            </li>
                        </ul>
                    </div>

        </div>

    </div>
</template>

<script>
    import yzcode from './../public/yzcode'
    import Title from '../public/title'
    import '../../assets/css/user.css'
    export default {
        name: "info",
        components: {
            yzcode,
            Title
        },
        data (){
            return {

                tabs: ['基本资料', '修改密码'],
                tab_active: 0,

                isInit: true,
                info: null,
                nickUpdate: false,
                nickname: '',

                password1: '',
                password2: '',
                password3: '',
                yzmcode: '',
                yzm: '',
                pwd2_err: false,
                pwd3_err: false,
                changeCode: 0
            }
        },
        activated() {
            let that = this
            this.$get(that.$api.memberinfo).then(function (res) {
                if (res.code === 1){
                    let info = res.data.info
                    that.info = info
                    that.nickname = info.name
                    that.isInit = false
                }
            })
        },
        methods: {
            titleTabActive(v){
              this.tab_active = v
            },
            valcode(v){
                this.yzm = v
            },
            updateNK(){
                this.nickUpdate = true
            },
            cancelNK(){
                this.nickUpdate = false
            },
            submitNK(){
                let that = this
                if(this.nickname===''){
                    this.$nextTick(() =>{
                        this.$refs.nick.focus()
                    })
                    return
                }
                that.$toast.loading({
                    message: '请稍后',
                    duration: 0,
                    forbidClick: true
                })
                setTimeout(function () {
                    that.$post(that.$api.member_upnick, {nick: that.nickname}).then(function (res) {
                        if (res.code === 1){
                            that.info.name = that.nickname
                            that.nickUpdate = false
                            that.$toast.success({message: res.msg})

                            let userInfo = JSON.parse(localStorage.getItem('user'))
                            userInfo.name = that.nickname
                            that.$store.commit('SET_USER', userInfo)

                        }
                    })
                }, 200)
            },
            updatePwd(){
                let that = this
                // return
                this.pwd2_err = false
                this.pwd3_err = false
                if(that.password1 === ''){
                    this.$toast('请输入旧密码')
                    this.$nextTick(() =>{
                        this.$refs.lgpwd1.focus()
                    })
                    return
                }
                if(that.password2 === '' || that.password2.length < 6 ||that.password2.length>20){
                    this.$nextTick(() =>{
                        this.pwd2_err = true
                        this.$refs.lgpwd2.focus()
                    })
                    return
                }
                if(that.password3 === '' || that.password3 !== that.password2){
                    this.$toast('两次新密码必须一致')
                    this.$nextTick(() =>{
                        this.pwd3_err = true
                        this.$refs.lgpwd3.focus()
                    })
                    return
                }
                if(that.yzmcode === ''){
                    this.$toast('请输入验证码')
                    this.$nextTick(() =>{
                        this.$refs.lgcode.focus()
                    })
                    return
                }
                if(that.yzmcode !== that.yzm){
                    this.$toast('验证码不正确')
                    this.$nextTick(() =>{
                        this.$refs.lgcode.focus()
                    })
                    return
                }
                that.$post(that.$api.member_uppwd, {pwd1: btoa(that.password1), pwd2: btoa(that.password2)}).then(function (res) {
                    if(res.code === 1) {
                        that.$toast.success(res.msg)
                        that.password1 = ''
                        that.password2 = ''
                        that.password3 = ''
                        that.yzmcode = ''
                        that.changeCode = Math.random()
                    }
                    else{
                        that.$toast.fail(res.msg)
                        that.yzmcode = ''
                        that.changeCode = Math.random()
                    }
                })

            },
        },
    }
</script>

<style scoped>

</style>
